import {ChangeDetectorRef, Component, OnInit, Input} from "@angular/core";
import {NotificationService} from "~/app/core/notification.service";
import {ApiService} from "~/app/core/api.service";
import * as Log from "~/app/core/log";
import {OfferThumbnailInfo} from "~/app/core/model/offer-thumbnail-info";
import {OfferInfo} from "~/app/core/model/offer-info";
import {OfferService} from "~/app/core/offer-service/offer.service";
import {OfferListHorizontalComponent} from "~/app/components/offer-list-horizontal/offer-list-horizontal.component";
import {off} from "@angular/fire/database";
import {AddressInfo} from "~/app/core/model/address-info";
import {LocationInfo} from "~/app/core/model/location-info";
import {CoreService} from "~/app/core/core.service";

@Component({
    selector: "small-offer-view",
    templateUrl: "./small-offer-view.component.html",
    styleUrls: ["./small-offer-view.component.scss"]
})
export class SmallOfferViewComponent implements OnInit {
  @Input() offer: OfferInfo;
  @Input() offerThumbnail: OfferThumbnailInfo;

  constructor(
    private readonly api: ApiService,
    private readonly cd: ChangeDetectorRef,
    private readonly offerService: OfferService,
    private offerList: OfferListHorizontalComponent,
    private readonly core: CoreService,
  ) {
  }

  ngOnInit(): void {
  }

  public setFavorite() {
    this.offerService.favoriteOffer(this.offer.id);
    this.offer.favorite = true;
    this.offerList.reloadOffers();
  }

  public unsetFavorite() {
    this.offerService.unfavoriteOffer(this.offer.id);
    this.offer.favorite = false;
    this.offerList.reloadOffers();
  }

  public displayOffer(offerID: number) {
    this.offerList.displayOffer(offerID)
  }
}
